import { useNavigate } from "react-router-dom";
import { AdminTemplate, MerchantTaxNumberList } from "../../components";

export const MerchantTaxNumber = () => {
  const navigate = useNavigate();

  const handleAddButton = () => navigate("/merchant-management/merchant-identification");

  return (
    <AdminTemplate
      headerProps={{
        headerTitle: "Vergi Numarası Aynı Olan İşyeri Listeleme",
        onClickAddButton: handleAddButton,
      }}
    >
      <MerchantTaxNumberList />
    </AdminTemplate>
  );
};
